var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer mt-auto py-3 home-dark-green-bg"})}
var staticRenderFns = []

export { render, staticRenderFns }